import React from "react";
import ReactModal from "react-modal";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const ModalNotFound = ({ isOpen, onRequestClose, message, description = "" }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
      className="error-modal"
      style={{
        overlay: {
          zIndex: "9999",
        },
      }}
    >
      <div className="error-content">
        <div className="error-header">
          <h4 className="error-title"></h4>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={onRequestClose}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div className="error-body">
        <div className="row mt-2">
            <div className="col-sm-12 text-lg-center">
              <FontAwesomeIcon
                size="5x"
                color="black"
                icon={faExclamationCircle}
              />
            </div>
          </div>
          <div className="row fixed-bottom position-absolute mb-4">
            <div className="col-sm-12 text-lg-center">
              <h5>{message}</h5>
            </div>
            <div className="col-sm-12 text-lg-center">
              <p>{description}</p>
            </div>
          </div>
        </div>
        <div className="error-footer">
          <button
            type="button"
            className="btn btn-primary mr-3"
            onClick={onRequestClose}
          >
            Close
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default ModalNotFound;
